import { gql } from '__generated__'

/** Demo Up/Down rounds of the session: the pool screen and the guest-session claim (FE-310). */
export const GET_DEMO_UP_DOWN_QUOTA = gql(`
  query getDemoUpDownQuota {
    getDemoUpDownQuota {
      enabled
      registered
      roundsLimit
      roundsPlayed
      roundsLeft
      canPlay
    }
  }
`)
